<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-audiencias
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-child mr-2'></i>Audiencias</h4>"
          v-else
        ></table-audiencias>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableAudiencias from "./TableAudiencias";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "facebookPages",
  components: {
    TableAudiencias,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "code", label: "Código", sortable: true },
        { key: "subtype", label: "Subtipo de audiencia", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getAudiencias();
  },
  methods: {
    getAudiencias() {
      var audiencias = store.getters.getAudiencias;
      if (audiencias.length == 0) {
        this.isLoading = true;
        store.dispatch("getAudiencias").then(() => {
          audiencias = store.getters.getAudiencias;
          shuffleArray([audiencias]);
          this.isLoading = false;
          this.items = audiencias;
          this.itemsArray = audiencias;
        });
      } else {
        shuffleArray([audiencias]);
        this.items = audiencias;
        this.itemsArray = audiencias;
      }
    }
  }
};
</script>
